import { render } from "./SquadDuty.vue?vue&type=template&id=45b8d964"
import script from "./SquadDuty.vue?vue&type=script&lang=js"
export * from "./SquadDuty.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__